import { useAppSelector } from 'shared';

export const useCakeToOrderPageState = () => useAppSelector(
    (store) => store.cakeToOrderPage,
);
